/* eslint-disable no-console */

export default function logToConsole(message) {
    var console = window.console;

    if (typeof(console) != "undefined" && console.log) {
        console.log(message);
    }
}


// WEBPACK FOOTER //
// ./node_modules/@progress/kendo-drawing/dist/es/common/log-to-console.js